import { useQuery } from 'react-query';
import { http } from 'services';
import { useTranslation } from 'react-i18next';

interface Organization {
  id: number;
  name_uz: string | null;
  name_ru: string | null;
  name_en: string | null;
  name_oz: string | null;
}

const useOrganizations = () => {
  const {
    i18n: { language }
  } = useTranslation();

  const { data = [], isLoading, isFetched, ...rest } = useQuery(
    ['organizations-with-child-all'],
    async () => {
      const { data } = await http.request.get('/admin/handbook/organizations-with-child-all');
      return (data?.data || []) as Organization[];
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      initialData: [],
      select: (organization) => organization.reduce((acc, org) => ({
        ...acc,
        [org.id]: {
          id: org.id,
          label: org[`name_${language}` as keyof Organization] || org.name_uz || '',
          value: String(org.id)
        }
      }), {} as Record<string, { id: number; label: string; value: string }>)
    }
  );

  return {
    items: data,
    isLoading,
    isFetched,
    ...rest
  };
};

export default useOrganizations;
